const firebaseConfig = {
  apiKey: "AIzaSyBsYerfBAr54lDSwbU8ACI5-O9u7JamIwo",
  authDomain: "tervy-ac8d9.firebaseapp.com",
  databaseURL: "https://tervy-ac8d9.firebaseio.com",
  projectId: "tervy-ac8d9",
  storageBucket: "tervy-ac8d9.appspot.com",
  messagingSenderId: "12282903970"
};

export default firebaseConfig